// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32XYC","content":"styles_content__17jIX","tableWrap":"styles_tableWrap__E9AVb"};